const info = {
  ZH: {
    //中文翻译
    pay: "账单付款",
    detail: "账单详情",
    data: "账单日期",
    sum: "金额",
    num: "账单号",
    salesman: "业务员",
    Creator: "创建人",
    creat: "创建日期",
    Payment: "支付方式",
    chose: "请选择",
    zfb: "支付宝",
    wx: "微信",
    SXF: "手续费",
    amount: "实付金额",
    Confirm: "确认支付",
    Recharge: "充值",
    delivery: "等待出仓",
    chucang: "已出仓",
    qianshou: "已签收",
    guo: "目的国家",
    guiji: "全部轨迹",
    gjxq: "轨迹详情",
    neir: "最新轨迹",
    shijian: "时间",
    weizhi: "位置",
    qianhsou: "签收时间",
    QSP: "签收人",
  },
  EN: {
    //英文翻译
    pay: "Bill payment",
    data: "billing date",
    detail: "Bill details",
    sum: "money",
    salesman: "salesman",
    num: "bill number",
    Creator: "Creator",
    creat: "Creation date",
    Payment: "Payment method",
    chose: "Please select",
    zfb: "ZFB",
    wx: "WX",
    SXF: "Service Charge",
    amount: "Paid in amount",
    Confirm: "Confirm payment",
    Recharge: "Recharge",
    delivery: "Waiting for delivery",
    chucang: "Out of warehouse",
    qianshou: "Signed in",
    guo: "Destination country",
    guiji: "AllTracks",
    gjxq: "Track details",
    neir: "Latest track",
    shijian: "time",
    weizhi: "position",
    qianhsou: "Signing time",
    QSP: "Signed by",
  },
};
export default info;
